<div
  class="bewp-toast-notification"
  [class]="containerClass"
>
  <svg
    *ngIf="hasIcon"
    viewBox="0 0 100 100"
    class="bewp-toast-notification__icon"
    [ngClass]="'bewp-toast-notification__icon--' + _toast.notificationType"
  >
    <use
      *ngIf="_toast.notificationType === 'error'"
      class="bewp-error-icon"
      href="assets/icons-v2/sprites.svg#error-diamond-bold"
    ></use>
    <use
      *ngIf="_toast.notificationType === 'warning'"
      class="bewp-warning-icon"
      href="assets/icons-v2/sprites.svg#warning-triangle-bold"
    ></use>
    <use
      *ngIf="_toast.notificationType === 'success'"
      class="bewp-success-icon"
      href="assets/icons-v2/sprites.svg#check-circle-bold"
    ></use>
    <use
      *ngIf="_toast.notificationType === 'information'"
      class="bewp-information-icon"
      href="assets/icons-v2/sprites.svg#information-circle-bold"
    ></use>
  </svg>
  <p class="bewp-toast-notification__text">{{ _toast.text }}</p>
  <button
    *ngIf="_toast.hasCloseButton"
    class="bewp-toast-notification__close-btn"
    (click)="removeToast.emit(_toast)"
  >
    Close
  </button>
</div>
